export const REPORT_FILTERS_WIDGET_NAMESPACE = 'widget.report-filters'
